import { Box, InputLabel } from '@mui/material';

import { InputType, InputFormField } from 'types';
import { QuestionLabel } from 'components/question-label';

import { InputField, DatePickerField } from '../fields';

export const FormInputField = ({
  id,
  label,
  options,
  placeholder,
}: InputFormField) => (
  <Box>
    <InputLabel component="div" className="mb-2">
      <QuestionLabel value={label} />
    </InputLabel>
    {options?.type === InputType.Date ? (
      <DatePickerField name={id} fullWidth placeholder={placeholder} />
    ) : (
      <InputField
        name={id}
        fullWidth
        type={options?.type}
        placeholder={placeholder}
        multiline={options?.multiline}
      />
    )}
  </Box>
);
